import { gql } from "lib/apolloClient";

export const studentReportFragments = {
  reportFeed: gql`
    fragment studentReportItem on PublishedStudentProgressReport {
      id
      filteredNodes
      publishedAt
      studentProgressReport {
        id
        courseProgressReportTask {
          id
          title
        }
      }
      curriculumProgram {
        id
        type
      }
    }
  `,
};
